import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  DealsNag,
  LoadingCart,
  ReviewApproved,
  ReviewCart,
  ReviewRejected,
} from 'src/components';
import {
  useCurrentUser,
  useGetCartQuery,
  useRedirectToUpperCase,
  useScrollToTop,
  useVendorDeals,
} from 'src/hooks';
import { reviewCartIdAtom } from 'src/store';

export const Review = () => {
  const { user } = useCurrentUser();
  const [cartId, setCartId] = useAtom<string>(reviewCartIdAtom);

  const { cartId: cartIdParam, response: responseParam } = useParams();
  const cartQuery = useGetCartQuery({ cartId: cartIdParam || '' });
  useVendorDeals({ cartId: cartIdParam });

  const navigate = useNavigate();

  useScrollToTop();
  useRedirectToUpperCase({
    cartIdParam,
    setCartId,
    pathname: 'review',
  });

  useEffect(() => {
    if (
      !user ||
      !user.subscription.tier ||
      user.subscription.tier !== 'organization'
    ) {
      navigate(`/get${cartId ? `/${cartId}` : ''}`);
    }
  }, [cartId, navigate, user]);

  if (cartQuery.isLoading) {
    return (
      <LoadingCart customTextColor='text-primary' customBgColor='bg-white' />
    );
  }

  const cartOriginallyRequestedBy =
    cartQuery.data?.approvalDetails?.at(0)?.requestedBy?.email ||
    cartQuery.data?.approvalDetails?.at(0)?.requestedBy?.name ||
    '';

  return (
    <>
      <div
        className='overflow-x-clip'
        style={{ minHeight: window.innerHeight - 300 }}
      >
        {responseParam === 'rejected' ? (
          <ReviewRejected cartRequestedBy={cartOriginallyRequestedBy} />
        ) : responseParam === 'approved' ? (
          <ReviewApproved cartRequestedBy={cartOriginallyRequestedBy} />
        ) : (
          <ReviewCart cartId={cartId} cartQuery={cartQuery} />
        )}
      </div>
      <DealsNag source='nag-review' />
    </>
  );
};
